import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 账户相关
const article = new Restful(project, 'article')

article.getCount = function(data) {
  const url = project + 'article/status/count'
  return http.get(url, data).then(res => {
    return res
  })
}
article.getAuthor = function(data) {
  const url = project + 'article/author'
  return http.get(url, data).then(res => {
    return res
  })
}
article.getFound = function(keyword) {
  const url = project + 'article/found/remote'
  return http.get(url, { keyword }).then(res => {
    return res
  })
}
article.getKeyword = function(query) {
  const url = project + 'article/keyword'
  return http.get(url, { limit: 20, delimiter: ' ,', query }).then(res => {
    return res
  })
}
article.checkTitle = function(title) {
  const url = project + 'article/title'
  return http.get(url, { title }).then(res => {
    return res
  })
}
article.parseXML = function(data) {
  const url = project + 'article/jats'
  return http.post(url, data).then(res => {
    return res
  })
}
article.changeStatus = function(data) {
  const url = project + 'article/status'
  return http.put(url, data).then(res => {
    return res
  })
}
article.getByCode = function(code, data) {
  const url = project + 'article/code/' + code
  return http.get(url, data).then(res => {
    return res
  })
}
article.import = function(data) {
  const url = project + 'article/import'
  return http.put(url, data).then(res => {
    return res
  })
}
article.issueXML = function(id) {
  const url = project + 'article/issue/' + id + '/xml'
  return http.put(url).then(res => {
    return res
  })
}
article.related = function(data) {
  const url = project + 'article/related'
  return http.get(url, data).then(res => {
    return res
  })
}
article.getProgress = function(id) {
  const url = project + 'import/progress/ISSUE_XML/' + id
  return http.get(url).then(res => {
    return res
  })
}
export default article
